import * as React from 'react';

export const IconSharing = (props: React.HTMLAttributes<SVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width="12" height="12">
    {/* tslint:disable-next-line:max-line-length */}
    <path
      fill="#2b87db"
      fillRule="evenodd"
      d="M2.118 8.118c.57 0 1.088-.227 1.468-.595L7.782 9.62a2.118 2.118 0 1 0 .63-1.262L4.22 6.262c.01-.086.016-.173.016-.26 0-.09-.007-.176-.017-.26L8.413 3.64a2.118 2.118 0 1 0-.63-1.263l-4.2 2.1a2.118 2.118 0 1 0-1.468 3.64z"
    />
  </svg>
);
